export const defaultSemenPullColDef = {
  sortable: true,
  pivot: false,
  filter: true,
  wrapText: false,
  resizable: true,
  autoHeight: false,
  wrapHeaderText: true,
  autoHeaderHeight: true,
  enableValue: false,
  enableRowGroup: true,
  enablePivot: false,
  cellClassRules: { centered: () => true },
  headerClass: 'centered',
};
